const moment = require('moment');


export const licenseInitialValues = (data) => {

    let licenseValues = licenseFieldProps

   

    //Modify this if you add things.
    if(data !== undefined) {

        //licenseValues.license_country = data.drivers_license_issuing_country
        //licenseValues.license_state = data.drivers_license_issuing_state
        licenseValues.license_number = data.drivers_license_number
    
        licenseValues.license_first_name = data.drivers_license_first_name
        licenseValues.license_middle_name = data.drivers_license_middle_name
        licenseValues.license_last_name = data.drivers_license_last_name
    
        licenseValues.license_birth_year = moment(data.drivers_license_date_of_birth, 'YYYY-MM-DD').format('YYYY')
        licenseValues.license_birth_month = moment(data.drivers_license_date_of_birth, 'YYYY-MM-DD').format('MM')
        licenseValues.license_birth_date = moment(data.drivers_license_date_of_birth, 'YYYY-MM-DD').format('D')
    
        licenseValues.license_exp_year = moment(data.drivers_license_exp, 'YYYY-MM-DD').format('YYYY')
        licenseValues.license_exp_month = moment(data.drivers_license_exp, 'YYYY-MM-DD').format('MM')
        licenseValues.license_exp_date = moment(data.drivers_license_exp, 'YYYY-MM-DD').format('D')

        licenseValues.license_gender = data.drivers_license_gender

        licenseValues.address_line_1 = data.address_line_1
        licenseValues.address_line_2 = data.address_line_2
        licenseValues.address_city = data.address_city
        licenseValues.address_region = data.address_region
        licenseValues.address_country = data.address_country
        licenseValues.address_postal_code = data.address_postal_code

    }
    return licenseValues

}

export const licenseFieldProps = {

    //license_country: '',
    //license_state: '',
    license_number: '',

    license_first_name: '',
    license_middle_name: '',
    license_last_name: '',

    license_birth_year: '',
    license_birth_month: '',
    license_birth_date: '',

    license_exp_year: '',
    license_exp_month: '',
    license_exp_date: '',

    license_gender : '',

    license_birth_combo : '', //this is so formik's errors will play nice.
    license_exp_combo : '', //see above.
    
    address_line_1 : '',
    address_line_2 : '',
    address_city : '',
    address_region : '',
    address_country : '',
    address_postal_code : ''

}

export const licenseFieldsErrorProps = {

    //license_country: false,
    //license_state: false,
    license_number: false,
    
    license_first_name: false,
    license_middle_name: false,
    license_last_name: false,

    license_birth_combo : false,
    license_exp_combo : false,

    license_gender : false,

    address_line_1 : false,
    address_line_2 : false,
    address_city : false,
    address_region : false,
    address_country : false,
    address_postal_code : false

}